import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DownloadService } from '@shared/components/download-dialog/download.service';
import { Course } from '@shared/models/course.model';
import { environment } from '@env/environment';
@Component({
  selector: './download-dialog.component',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss']
})
export class DownloadDialogComponent implements OnInit {
  public course: Course;
  public mode: string;
  public bundleSize: number;
  downloadLink: string;
  constructor(
    private downloadService: DownloadService,
    private dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { course: Course }
  ) {

  }
  ngOnInit(): void {
    this.dialogRef.updateSize('40vw', '30vh');
    this.course = this.data.course;
    this.mode = 'initializing';
    this.downloadService.getDownloadInfo(this.course.id).subscribe(result => {
      console.log(result);
        this.mode = 'downloadready';
        this.bundleSize = result.size;
    }, error => {
      this.mode = 'downloadimpossible';
    });
    
  }

  downloadBundle(): void{
    this.mode = 'processing';
    this.downloadService.downloadBundle(this.course.id).subscribe(data => {
      this.mode = 'ended';
      this.downloadLink = environment.assetManagerUrl + data.location;
      this.launchDownload();
    });
  }
  launchDownload(): void{
    window.open(this.downloadLink, '_blank');
  }
  onClose(): void {
    this.dialogRef.close();
  }

}
